import LeftArrow from 'components/common/buttons/leftArrow'
import RightArrow from 'components/common/buttons/rightArrow'
import { ArrowContainer } from './selectionArrows_styles'

const SelectionArrows = props =>
  <ArrowContainer {...props}>
    <LeftArrow onClick={props.clickLeft} />
    <RightArrow onClick={props.clickRight} />
  </ArrowContainer>

export default SelectionArrows
